import VesselMetricsData from "./data";

export default function vesselMetricsDataFromJson(json) {
  return new VesselMetricsData(
    json.Trim,
    json.Mean_Draft,
    json.preds
  );
}
